import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { dataFieldNamingHandler, exceptionHandler, paramsFieldNamingHandler, } from '../../../base/decorators';
import { NetworkRequestService } from '../../../base/request/network-request';
import { FolderRepository } from '../repository/folder-repository';
import { lockOnce } from '@tencent/ark-utils/lib/decorator/lock';
var FolderDomainService = /** @class */ (function () {
    function FolderDomainService() {
        this.folderRepository = new FolderRepository(new NetworkRequestService());
    }
    /**
     * 初始化 Folder 领域
     * 提供空实现
     */
    FolderDomainService.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    FolderDomainService.prototype.folderList = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.folderRepository.folderList(params)];
            });
        });
    };
    FolderDomainService.prototype.newFolder = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.folderRepository.newFolder(params)];
            });
        });
    };
    FolderDomainService.prototype.addToMyFolder = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.folderRepository.addToMyFolder(params)];
            });
        });
    };
    __decorate([
        lockOnce(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], FolderDomainService.prototype, "init", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], FolderDomainService.prototype, "folderList", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], FolderDomainService.prototype, "newFolder", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        paramsFieldNamingHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], FolderDomainService.prototype, "addToMyFolder", null);
    return FolderDomainService;
}());
export { FolderDomainService };
